<template>
  <div v-if="!isEnterprisePlan">
    <div class="object-titlebox">
      <div class="object-titlebox-left" v-t="'message.title_setting_client_permit_ip_address'"></div>
    </div>
    <div class="object-inner-table">
      <table width=100%>
        <td width=50% class="object-item" v-t="'message.info_need_purchase_enterprise_plan'">
        </td>
      </table>
    </div>
  </div>
  <div v-else>
    <div class="object-titlebox">
      <div class="title-box-left">
        <span v-t="'message.title_setting_client_permit_ip_address'"></span>
        <div class="title-box-right">
          <button class="transparent" type="button" v-on:click="showEditPermitIpAddressDialog()"><img
            src="../../../../assets/edit.svg"/><span class="normal-command-text"
                                                     v-t="'message.common_action_edit'"></span></button>
        </div>
      </div>
    </div>
    <div v-if="!allowAll">
      <table width="100%">
        <tr class="object-titlebox">
          <td class="header-value" width="200px" style="padding-left:20px" v-t="'message.item_ip_address'"></td>
          <td class="header-value" style="padding-left:15px" v-t="'message.item_comment'"></td>
        </tr>
        <tr v-for="permitIp in permitIpAddressList" class="ip-address-record">
          <td class="object-value" width="200px" style="padding-left:20px">{{ permitIp.definedIp }}</td>
          <td class="object-value">{{ permitIp.description }}</td>
        </tr>
      </table>
    </div>
    <div v-else>
      <div class="object-value" colspan="2" style="padding-left:20px" v-t="'message.info_all_ip_address_has_permitted'">
        。
      </div>
    </div>
    <EditClientPermitIpAddress v-if="showEditPermitIpAddress" ref="editPermitIpAddress"
                               :initialAllowAll="allowAll" :permitIpAddressList="permitIpAddressList"
                               @save="modifyPermitIpAddressList"
                               @cancel="showEditPermitIpAddress=false"></EditClientPermitIpAddress>
  </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from "../../../commonutil.js";
import constants from "../../../constants.js";
import EditClientPermitIpAddress from "@/components/pc/setting/permitip/ClientPermitIpSettingEdit.vue";

export default {
  data() {
    return {
      permitIpAddressList: [],
      showEditPermitIpAddress: false,
      managementUserRights: false,
      allowAll: true,
    };
  },
  computed: {
    isEnterprisePlan() {
      return commonUtil.isEnterprisePlan(this.appData);
    },
  },
  methods: {
    getUserRights() {
      let self = this;
      server.post("/getinfo", {
          tenantId: this.appData.tenantList[0].tenantId,
          id: this.appData.loginUserObjectId,
          userTalkgroupInfo: false,
        },
      ).then((res) => {
        switch (res.data.status) {
          case constants.STATUS_SUCCESS:
            self.managementUserRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
            break;
          case constants.STATUS_ERROR_DENIED:
            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_confirm_rights_by_denied"));
            break;
          case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_object_not_found_user"));
            break;
          default:
            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getUserRights").replace("{code}", res.data.status));
            break;
        }
      })
        .catch(function (error) {
          commonUtil.putExceptionErrorMessage(self, "getUserRights", error);
        });
    },
    getClientIpPermissionType() {
      let self = this;
      server.post("/getclientippermissiontype")
        .then((res) => {
          switch (res.data.status) {
            case constants.STATUS_SUCCESS:
              self.allowAll = res.data.allowAll;
              break;
            default:
              commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getClientIpPermissionType").replace("{code}", res.data.status));
              break;
          }
        })
        .catch(function (error) {
          commonUtil.putExceptionErrorMessage(self, "getClientIpPermissionType", error);
        });
    },
    getPermitIpAddressList() {
      let self = this;
      server.post("/getclientpermitipaddresslist")
        .then((res) => {
          switch (res.data.status) {
            case constants.STATUS_SUCCESS:
              self.permitIpAddressList = res.data.ipAddressList;
              self.permitIpAddressList.sort(function (a, b) {
                return commonUtil.compareIpAddress(a.definedIp, b.definedIp);
              });
              break;
            default:
              commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getPermitIpAddressList").replace("{code}", res.data.status));
              break;
          }
        })
        .catch(function (error) {
          commonUtil.putExceptionErrorMessage(self, "getPermitIpAddressList", error);
        });
    },
    showEditPermitIpAddressDialog() {
      if (!this.managementUserRights) {
        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_operate_no_tenantAdmin_privilege"));
        return;
      }
      this.showEditPermitIpAddress = true;
    },
    modifyPermitIpAddressList(inputParam) {
      let self = this;
      if (inputParam.requestType == 1) {
        if (inputParam.addIpAddressList.length == 0 && inputParam.modifyIpAddressList.length == 0 && inputParam.removeIpAddressList.length == 0) {
          commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(self.$i18n, "info_no_changing_information"));
          this.showEditPermitIpAddress = false;
          return;
        }
      }
      let param = { requestType: inputParam.requestType, allowAll: inputParam.allowAll };
      if (inputParam.addIpAddressList.length > 0) {
        param.addIpAddressList = inputParam.addIpAddressList;
      }
      if (inputParam.modifyIpAddressList.length > 0) {
        param.modifyIpAddressList = inputParam.modifyIpAddressList;
      }
      if (inputParam.removeIpAddressList.length > 0) {
        param.removeIpAddressList = inputParam.removeIpAddressList;
      }
      server.post("/modifyclientpermitipaddresslist", param)
        .then((res) => {
          switch (res.data.status) {
            case constants.STATUS_SUCCESS:
              this.showEditPermitIpAddress = false;
              commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_permit_ip_address_modified"));
              self.getPermitIpAddressList();
              self.allowAll = inputParam.allowAll;
              break;
            case constants.STATUS_ERROR_PERMISSION_DENIED:
              commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_operate_no_tenantAdmin_privilege"));
              break;
            default:
              commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "modifyPermitIpAddressList").replace("{code}", res.data.status));
              break;
          }
        })
        .catch(function (error) {
          commonUtil.putExceptionErrorMessage(self, "modifyPermitIpAddressList", error);
        });
    },
  },
  components: {
    EditClientPermitIpAddress,
  },
  mounted: function () {
  },
  created: function () {
    this.getUserRights();
    this.getClientIpPermissionType();
    this.getPermitIpAddressList();
  },
  watch: {},
  props: ["appData"],
};

</script>

<style scoped>
.ip-address-record {
  color: #848991;
  border-bottom: 1px #eee solid;
  display: block;
}

.object-value {
  padding: 10px 10px;
}

.header-value {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #848991;
  font-size: 12px;
}

.title-box-right {
  position: relative;
  text-align: right;
  vertical-align: middle;
  font-size: 12px;
  float: right;
}

.title-box-left {
  padding: 10px;
  padding-left: 20px;
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}
</style>
